import { render } from "./BizOverview.vue?vue&type=template&id=269a0dea&ts=true"
import script from "./BizOverview.vue?vue&type=script&lang=ts"
export * from "./BizOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__